import React from 'react';
import ReactTooltip from 'react-tooltip';
import { random } from 'lodash';
import ThermometerSegment from './ThermometerSegment';
import { percentString } from '../../utils';
var ThermometerSegments = function (_a) {
    var valueLabelPairs = _a.valueLabelPairs, tooltipMode = _a.tooltipMode;
    var values = valueLabelPairs.map(function (pair) { return pair.value; });
    var total = values.reduce(function (a, b) { return a + b; });
    var primarySegment = valueLabelPairs.find(function (q) { return q.severity === 'primary'; });
    var secondarySegment = valueLabelPairs.find(function (q) { return q.severity === 'secondary'; });
    var remainderSegment = valueLabelPairs.find(function (q) { return q.severity === undefined; });
    // the tooltip for the background (grey part) of the thermometer
    var backgroundTooltipValue = percentString((remainderSegment === null || remainderSegment === void 0 ? void 0 : remainderSegment.value) || 0, total);
    if (tooltipMode === 'first-value' && primarySegment) {
        backgroundTooltipValue = percentString(primarySegment.value, total);
    }
    var tooltipId = 'thermometer-segment-' + random(1, 10000000);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "thermometer__container" },
            React.createElement(ReactTooltip, { className: "accurity-tooltip", place: 'top', type: "dark", id: tooltipId }),
            React.createElement("div", { className: "thermometer__background", "data-tip": backgroundTooltipValue, "data-for": tooltipId }),
            primarySegment && React.createElement(ThermometerSegment, { widthPercent: percentString(primarySegment.value, total), severity: 'primary', tooltipId: tooltipId }),
            secondarySegment && React.createElement(ThermometerSegment, { widthPercent: percentString(secondarySegment.value, total), severity: 'secondary', tooltipId: tooltipId }))));
};
export default ThermometerSegments;
//# sourceMappingURL=ThermometerSegments.js.map